// Destination institutions explicitly attached to the path, not feeder providers
// or other institutions that happen to offer the same credential.
export function associatedPathwaySchools(pathway) {
  const seen = new Set()
  const schools = []
  for (const offering of (pathway && pathway.uni_offered_programs) || []) {
    const school = offering && offering.university
    const key = school && (school.id || school.slug)
    if (!key || seen.has(key)) continue
    seen.add(key)
    schools.push({ ...school, program_offering: offering })
  }
  return schools
}
